/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BaseResponseDocumentCategoryWithTagsResponse,
  BaseResponseListCompanyResponse,
  BaseResponseListDocumentCategoryTagResponse,
  BaseResponseListString,
  BaseResponseMapStringObject,
  GetCompanyAutocompleteParams,
  GetGroupedTagsParams,
  GetTagAutocompleteParams,
  ManageCompaniesRequest,
  ManageTagsRequest,
} from './data-contracts';
import {ContentType, HttpClient, RequestParams} from './http-client';

export class Tag<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 새로운 태그를 추가 또는 기존 태그의 순서를 변경하거나 삭제합니다. 문서 구분의 경우에도 동일하게 작동합니다.
   *
   * @tags Tag
   * @name ManageTags
   * @summary 문서 카테고리별 태그, 문서 구분 추가, 삭제 및 순서 변경
   * @request POST:/app/tags/{documentCategoryUuid}
   * @secure
   * @response `200` `BaseResponseMapStringObject` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  manageTags = async (documentCategoryUuid: string, data: ManageTagsRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseMapStringObject, void>({
      path: `/app/tags/${documentCategoryUuid}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 활성 상태의 법인 UUID와 이름을 반환합니다.
   *
   * @tags Tag
   * @name GetActiveCompanies
   * @summary 법인명 조회
   * @request GET:/app/tags/companies
   * @secure
   * @response `200` `BaseResponseListCompanyResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getActiveCompaniesKey = () => ['app', 'tags', 'companies'];

  getActiveCompanies = async (params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListCompanyResponse, void>({
      path: `/app/tags/companies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 새로운 법인명을 추가하고 기존 법인명을 삭제 상태(INACTIVE)로 변경합니다.
   *
   * @tags Tag
   * @name ManageCompanies
   * @summary 법인명 추가 및 삭제
   * @request POST:/app/tags/companies
   * @secure
   * @response `200` `BaseResponseMapStringObject` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  manageCompanies = async (data: ManageCompaniesRequest, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseMapStringObject, void>({
      path: `/app/tags/companies`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 카테고리를 기반으로 태그 종류 및 태그 리스트를 반환합니다.
   *
   * @tags Tag
   * @name GetTagsByDocumentCategory
   * @summary 문서 카테고리별 태그 조회
   * @request GET:/app/tags/{documentCategoryUuid}/tags
   * @secure
   * @response `200` `BaseResponseDocumentCategoryWithTagsResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getTagsByDocumentCategoryKey = (documentCategoryUuid: string) => ['app', 'tags', documentCategoryUuid, 'tags'];

  getTagsByDocumentCategory = async (documentCategoryUuid: string, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseDocumentCategoryWithTagsResponse, void>({
      path: `/app/tags/${documentCategoryUuid}/tags`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 문서 카테고리에 따라 태그를 반환
   *
   * @tags Tag
   * @name GetGroupedTags
   * @summary 문서 카테고리별 태그 조회
   * @request GET:/app/tags/grouped-tags
   * @secure
   * @response `200` `BaseResponseListDocumentCategoryTagResponse` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getGroupedTagsKey = (query: GetGroupedTagsParams) => ['app', 'tags', 'grouped-tags', query];

  getGroupedTags = async (query: GetGroupedTagsParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListDocumentCategoryTagResponse, void>({
      path: `/app/tags/grouped-tags`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 입력한 검색어를 기반으로 회사명 자동완성
   *
   * @tags Tag
   * @name GetCompanyAutocomplete
   * @summary 회사 자동완성
   * @request GET:/app/tags/companies/autocomplete
   * @secure
   * @response `200` `BaseResponseListString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getCompanyAutocompleteKey = (query: GetCompanyAutocompleteParams) => [
    'app',
    'tags',
    'companies',
    'autocomplete',
    query,
  ];

  getCompanyAutocomplete = async (query: GetCompanyAutocompleteParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListString, void>({
      path: `/app/tags/companies/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };

  /**
   * @description 입력한 검색어를 기반으로 태그 자동완성
   *
   * @tags Tag
   * @name GetTagAutocomplete
   * @summary 태그 자동완성
   * @request GET:/app/tags/autocomplete
   * @secure
   * @response `200` `BaseResponseListString` OK
   * @response `400` `void` 잘못된 요청 값
   * @response `401` `void` 인증되지 않음
   * @response `403` `void` 리소스 접근 권한 없음
   * @response `404` `void` 존재하지 않는 리소스
   * @response `500` `void` 서버 내부 에러
   */

  getTagAutocompleteKey = (query: GetTagAutocompleteParams) => ['app', 'tags', 'autocomplete', query];

  getTagAutocomplete = async (query: GetTagAutocompleteParams, params: RequestParams = {}) => {
    const response = await this.http.request<BaseResponseListString, void>({
      path: `/app/tags/autocomplete`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });

    return response;
  };
}
